import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const DigitalTimer = ({ maxTime, isRunning, onFinish, align = "center" }) => {
  const [time, setTime] = useState(maxTime);
  useEffect(() => {
    let timer;
    if (isRunning && time > 0) {
      timer = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
    }

    if (time === 0) {
      onFinish(); // Llamar al callback cuando el tiempo se agote
    }

    return () => clearInterval(timer); // Limpia el temporizador al desmontar o cambiar estado
  }, [isRunning, time, onFinish]);

  const formatTime = (time) => {
    const minutes = String(Math.floor(time / 60)).padStart(2, "0");
    const seconds = String(time % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const justifyContentMap = {
    center: "center",
    left: "flex-start",
    right: "flex-end",
  };

  return (
    <Box
      display="flex"
      alignItems="center"
     
      sx={{
        border: (theme) => `1px solid ${theme.palette.primary.main}`,
        borderRadius: 4,
        backgroundColor: (theme) => theme.palette.background.paper,
        boxShadow: (theme) => `0 4px 10px ${theme.palette.grey[300]}`,
        width: "fit-content",
        alignSelf: justifyContentMap[align], // Alineación adicional para flexibilidad
        paddingLeft: 3,
        paddingRight: 3,
        marginBottom: 1
      }}
    >
      <AccessTimeIcon
        sx={{
          fontSize: 16,
          color: (theme) => theme.palette.primary.main,
        }}
      />
      <Typography
        variant="h6"
        color="text.primary"
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          fontSize: 14
        }}
      >
        {formatTime(time)}
      </Typography>
    </Box>
  );
};

export default DigitalTimer;
